import { EditorService } from './editor';
import { StoreService } from './store';
const instanceMap = new Map();
export class Plugin {
    constructor(editorId, editor) {
        this.previousEditorTextContent = '';
        this.editorId = editorId;
        this.editor = editor;
        this.editorService = new EditorService(this);
        this.storeService = new StoreService(this);
        if (editor) {
            this.setPreviousEditorTextContent(this.editorService.getEditorTextContent(editor));
        }
    }
    static getInstance(config) {
        let { editorId, editor } = config || {};
        if (!editorId) {
            editorId = 'default';
        }
        if (!instanceMap.has(editorId)) {
            instanceMap.set(editorId, new Plugin(editorId, editor));
        }
        return instanceMap.get(editorId);
    }
    getPreviousEditorTextContent() {
        return this.previousEditorTextContent;
    }
    setPreviousEditorTextContent(textContent) {
        this.previousEditorTextContent = textContent;
    }
}
